var isDeviceTouchable = function isDeviceTouchable() {
  if ('ontouchstart' in document.createElement('div')) {
    return true;
  }
  if ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0) {
    return true;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if ('msMaxTouchPoints' in navigator && navigator.msMaxTouchPoints > 0) {
    return true;
  }
  var mQ = matchMedia('(pointer:coarse)');
  if (mQ && mQ.media === '(pointer:coarse)') {
    return mQ.matches;
  }
  if ('orientation' in window) {
    return true; // deprecated, only as fallback
  }
  // Only as a last resort, fall back to user agent sniffing
  return /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(navigator.userAgent) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(navigator.userAgent);
};
export var isTouchDevice = isDeviceTouchable;
export var useIsTouchDevice = isDeviceTouchable;